import { parseAsString, parseAsStringEnum, useQueryStates } from "nuqs";
import { useCallback, useMemo } from "react";

export type DmsActions =
  | `${"library" | "document" | "folder"}-${"add" | "edit" | "delete"}`
  | "document-move"
  | "document-view";

export const DMS_ACTIONS: DmsActions[] = [
  "library-add",
  "library-edit",
  "library-delete",
  "document-add",
  "document-edit",
  "document-delete",
  "document-view",
  "folder-add",
  "folder-edit",
  "folder-delete",
  "document-move",
];

export function useDmsDialogQueryState() {
  const [actionState, setActionState] = useQueryStates(
    {
      action: parseAsStringEnum(DMS_ACTIONS),
      actionPath: parseAsString,
      actionParentPath: parseAsString,
    },
    { history: "replace" }
  );
  const clearActionState = useCallback(() => {
    setActionState({
      action: null,
      actionPath: null,
      actionParentPath: null,
    });
  }, [setActionState]);
  return useMemo(
    () => ({ actionState, setActionState, clearActionState }),
    [actionState, setActionState, clearActionState]
  );
}
